import {useBusinessInfo} from "~/lib/Queries";
import {setBusinessId} from "~/lib/Api";
import * as Toast from "~/lib/Toast";

export const ACCESS_FULL = 'full';
export const ACCESS_LIMITED = 'limited';


const usePermissions = () =>
{
    const { data } = useBusinessInfo();

    const permissionData = data?.business?.pivot?.permissions || {};
    const level = permissionData?.role || ACCESS_FULL;

    function can(permission)
    {
        if (level === ACCESS_FULL) {
            return true;
        } else {
            return (permissionData?.permissions||[]).indexOf(permission) > -1;
        }
    }

    return {
        can
    }
}

export default usePermissions;
